import { render, staticRenderFns } from "./TagGroup.vue?vue&type=template&id=0a9b0fc4&"
import script from "./TagGroup.vue?vue&type=script&lang=ts&"
export * from "./TagGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports